/**
 * Language types for admin panel
 * Языки хранятся в БД и управляются через систему локализации
 */

/**
 * Ответ API при получении языка
 */
export interface Language {
  code: string;
  name: string;
  nativeName: string;
  flagEmoji: string;
  flag: string; // alias для flagEmoji (для совместимости)
  isDefault: boolean;
}

/**
 * Данные для создания языка
 */
export interface CreateLanguageInput {
  code: string;
  name: string;
  nativeName: string;
  flagEmoji: string;
}

/**
 * Данные для обновления языка
 */
export interface UpdateLanguageInput {
  name?: string;
  nativeName?: string;
  flagEmoji?: string;
}

/**
 * Common language flags mapping
 */
export const LANGUAGE_FLAGS: Record<string, string> = {
  ru: "🇷🇺",
  en: "🇬🇧",
  uz: "🇺🇿",
  kz: "🇰🇿",
  uk: "🇺🇦",
  de: "🇩🇪",
  fr: "🇫🇷",
  es: "🇪🇸",
  it: "🇮🇹",
  pt: "🇵🇹",
  zh: "🇨🇳",
  ja: "🇯🇵",
  ko: "🇰🇷",
  ar: "🇸🇦",
  tr: "🇹🇷",
};

/**
 * Get flag emoji for language code
 */
export function getFlagEmoji(code: string): string {
  return LANGUAGE_FLAGS[code.toLowerCase()] ?? "🌐";
}
